import React from 'react';
import ImageUploadInput from "./utils/ImageUploadInput";
import FormItem from "./utils/FormItem";

interface ImageUploadFieldProps {
  name: string;
  label: string;
  readOnly?: boolean;
  required?: boolean;
  top?: boolean;
  minImageSize?: { width: number; height: number };
  recommendedAspectRatio?: string;
}

const ImageUploadField: React.FC<ImageUploadFieldProps> = ({
  name,
  label,
  readOnly = false,
  required = false,
  top = false,
  minImageSize,
  recommendedAspectRatio
}) => {
  return (
    <FormItem label={label} top={top}>
      <ImageUploadInput
        name={name}
        readOnly={readOnly}
        required={required}
        minImageSize={minImageSize}
        recommendedAspectRatio={recommendedAspectRatio}
      />
    </FormItem>
  );
};

export default ImageUploadField;
